/*global _ */
import {notifyOrder} from '../../../../services/main'

const EventBus = window.VueEventBus
import {getCountryName, getStateName} from '../../../../lib/formatters'
import {formatDate} from '../../../../lib/dates'
import {getMyOrder} from '../../../../services/user'
import ComponentMixin from '../../../../mixins/components/complex-reactive'
import ProductMixin from '../../../../mixins/store/product'
import DesignerMixin from './designer'
// import nextActionMixinFactory from '../../../../designer/mixins/components/next-action'
// const NextActionMixin = nextActionMixinFactory(
//   {'customShoppingPageNavigation': true},
//   {customNavigateShoppingPage: 'customShoppingPageNavigation'},
// )

export default {
  name: 're-purchase-summary',
  settings: 'element.purchase-summary',
  translations: 'element.purchase-summary',
  mixins: [
    ComponentMixin,
    ProductMixin,
    DesignerMixin,
    // NextActionMixin
  ],
  props: {
    order: {},
    title: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$t('title', 'Thank you')
      }
    },
    containerClass: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$s('containerClass', '')
      }
    },
    showDownloadButton: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showDownloadButton', true)
      }
    },
    downloadButtonClass: {
      type: [String],
      default() {
        return this.$options.$$s('downloadButtonClass', '')
      }
    },
    downloadButtonTitle: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$t('downloadButtonTitle', 'Download Receipt')
      }
    },
    showEmailButton: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showEmailButton', true)
      }
    },
    emailButtonClass: {
      type: [String],
      default() {
        return this.$options.$$s('emailButtonClass', '')
      }
    },
    emailButtonTitle: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$t('emailButtonTitle', 'Email Receipt')
      }
    },
    showTransactionDate: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showTransactionDate', true)
      }
    },
    showPaymentMethods: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showPaymentMethods', true)
      }
    },
    showShippingAddress: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showShippingAddress', true)
      }
    },
    showShopButton: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showShopButton', true)
      }
    },
    shopButtonClass: {
      type: [String],
      default() {
        return this.$options.$$s('shopButtonClass', '')
      }
    },
    shopButtonTitle: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$t('shopButtonTitle', 'Continue Shopping')
      }
    },

    itemSummaryItems: {
      type: [Array, String],
      default() {
        return this.$options.$$s('itemSummaryItems', ['title', 'quantity', 'price', 'description'])
      }
    },
    orderSummaryItems: {
      type: [Array, String],
      default() {
        return this.$options.$$s('orderSummaryItems', ['subtotal', 'discount', 'shipping', 'tax', 'total'])
      }
    },
  },
  data() {
    return {
      orderDetails: null
    }
  },
  computed: {
    canShowDownloadButton() {
      return this.$$getData('showDownloadButton')
    },
    canShowEmailButton() {
      return this.$$getData('showEmailButton')
    },
    canShowTransactionDate() {
      return this.$$getData('showTransactionDate')
    },
    canShowPaymentMethods() {
      return this.$$getData('showPaymentMethods')
    },
    canShowShippingAddress() {
      return this.$$getData('showShippingAddress')
    },
    canShowShopButton() {
      return this.$$getData('showShopButton')
    },
    visibleItemParts() {
      return this.$$getData('itemSummaryItems')
    },
    canShowNameColumn() {
      return this.visibleItemParts.includes('title') ||
        this.visibleItemParts.includes('image') ||
        this.visibleItemParts.includes('description')
    },
    visibleOrderSummaryParts() {
      return this.$$getData('orderSummaryItems')
    },
    orderData() {
      return this.$$getData('orderDetails', {})
    },
    templateData() {
      return {
        email: this.orderUser.email,
        first_name: this.orderUser.first_name,
        last_name: this.orderUser.last_name,
        name: this.orderUser.first_name + ' ' + this.orderUser.last_name,
      }
    },
    orderTitle() {
      return this.parseReactiveValuesByTemplate(this.$$getData('title'), this.templateData)
    },
    orderId() {
      return _.get(this.orderData, 'invoice_number')
    },
    transactionDate() {
      const date = _.get(this.orderData, 'created_at')
      if (date) {
        return formatDate(date, 'dd.MM.yyyy')
      }
      return ''
    },
    paymentMethod() {
      const cardType = _.get(this.orderData, 'transaction.data.cc_type')
      if (cardType) {
        return 'Credit Card'
      }
      // @todo: Fix
      return 'Credit Card'
    },
    paymentMethodCardType() {
      return _.get(this.orderData, 'transaction.data.cc_type', '')
    },
    paymentMethodClass() {
      const cardType = this.paymentMethodCardType
      return cardType ? ('card-type-' + _.kebabCase(cardType)) : ''
    },
    orderUser() {
      return _.get(this.orderData, 'user.data', {})
    },
    orderUserMeta() {
      return _.get(this.orderUser, 'meta', {})
    },
    shippingAddress() {
      return _.filter([
        (_.get(this.orderUser, 'first_name') || '') + ' ' + (_.get(this.orderUser, 'last_name') || ''),
        _.get(this.orderUserMeta, 'address') || '',
        _.get(this.orderUserMeta, 'city') || '',
        getStateName(_.get(this.orderUserMeta, 'state') || ''),
        _.get(this.orderUserMeta, 'zip') || '',
        getCountryName(_.get(this.orderUserMeta, 'country') || ''),
        _.get(this.orderUser, 'email')
      ])
    },
    orderItems() {
      return _.get(this.orderData, 'items.data', {})
    },
    orderSubtotal() {
      return _.toFinite(_.get(this.orderData, 'price'))
    },
    orderDiscount() {
      return _.toFinite(_.get(this.orderData, 'price_discount')) +
        _.toFinite(_.get(this.orderData, 'fee_discount')) +
        _.toFinite(_.get(this.orderData, 'tax_discount')) +
        _.toFinite(_.get(this.orderData, 'shipping_fee_discount'))
    },
    orderShipping() {
      return _.toFinite(_.get(this.orderData, 'shipping_fees'))
    },
    orderTax() {
      return _.toFinite(_.get(this.orderData, 'tax'))
    },
    orderTotal() {
      return _.toFinite(_.get(this.orderData, 'total'))
    },
    invoiceUrl() {
      return _.get(this.orderData, 'invoice_url')
    }
  },
  async created() {
    const data = _.get(window.addiesaas, 'pageService.$data.cart.paid.order')
    if (data) {
      _.unset(window.addiesaas, 'pageService.$data.cart')
      this.orderDetails = data
    } else if (this.order) {
      try {
        const {data} = await getMyOrder({id: this.order})
        debugLog({data})
        this.orderDetails = data
      } catch (e) {
        await this.alert('Unable fetch purchase details.')
      }
    }
  },
  methods: {
    getOrderItemProduct(item) {
      return _.get(item, 'product.data') || {}
    },
    getOrderItemTitle(item) {
      return _.get(this.getOrderItemProduct(item), 'title')
    },
    getOrderItemImageSrc(item) {
      return this.getProductImage(this.getOrderItemProduct(item))
    },
    getOrderItemDescription(item) {
      return _.get(this.getOrderItemProduct(item), 'description')
    },
    getOrderItemQuantity(item) {
      return _.get(item, 'count')
    },
    getOrderItemPrice(item) {
      return item.single_price * this.getOrderItemQuantity(item)
    },
    download() {

    },
    async email() {
      await notifyOrder(this.orderData)
    },
    continueShopping() {
      if (this.customNavigateShoppingPage) {
        this.customNavigateShoppingPage()
      }
    }
  }
}
